// extracted by mini-css-extract-plugin
export default {"divider":"divider-module__divider____VSSM"};